<template>
  <div>
    <div class="container-fluid">
      <div id="section-2-top">
        <h2>Les avantages du Débit Différé</h2>
        <p>
          Grâce au Débit Différé, regroupez toutes vos dépenses effectuées par carte
          en magasin ou sur internet, en un seul prélèvement.

        </p>
      </div>
      <div class="section-2-box">
        <div>
          <img src="../assets/images/icon-1.png" alt="" class="img-fluid" />
        </div>
        <div>
          <h3>
            + de tranquillité
          </h3>
          <p>
            Envie d’un week-end pour décompresser ou besoin de faire réparer votre voiture en panne ?
            <br />Gérez facilement et sans stress toutes vos <b>dépenses prévues ou imprévues.</b>
          </p>
        </div>
      </div>
      <div class="section-2-box">
        <div>
          <img src="../assets/images/icon-2.png" alt="" class="img-fluid" />
        </div>
        <div>
          <h3>
            + de simplicité
          </h3>
          <p>
            Pour tous vos achats par carte, en magasin ou sur internet, toutes vos dépenses sont
            <b>regroupées et débitées une fois par mois à date régulière</b>, sans frais, ni mensualité.
          </p>
          <p>
            Seuls vos retraits d’espèces sont débités immédiatement.
          </p>
        </div>
      </div>
      <div class="section-2-box">
        <div>
          <img src="../assets/images/icon-3.png" alt="" class="img-fluid" />
        </div>
        <div>
          <h3>
            + de contrôle
          </h3>
          <p>
            Toutes vos dépenses sont consultables à tout moment sur votre Espace Crédit Agricole en ligne depuis
            votre ordinateur ou sur votre application Ma Banque avec votre mobile.
          </p>
          <p>
            Vous pouvez facilement <b>anticiper un virement</b> pour compléter votre trésorerie si besoin, avant la
            date de prélèvement.
          </p>
        </div>
      </div>
      <p class="text-center">
        <a
          :href="cta"
          class="the-button"
          target="_top"
          data-trackingclass="landing-page-clic-bouton"
          data-trackinginfo="landing-page-CAPS-debitdiffere-cta-rdv-milieu"
        >
          demandez le Débit Différé pour votre carte
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cta: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Avantages.vue